export default "__VITE_ASSET__WF1L_QCs__"